import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { authKeys } from "@/lib/query";

const quickLoginSchema = z.object({
  accounts: z.array(
    z.object({ role: z.string(), label: z.string(), email: z.string(), password: z.string() }),
  ),
});

export type QuickLoginAccount = z.infer<typeof quickLoginSchema>["accounts"][number];

/**
 * The sandbox's one-click sign-in accounts (`src/lib/quick-login.ts`) — an
 * empty list everywhere else. Fixed for the life of the server, so read once.
 */
export function useQuickLogin() {
  return useQuery({
    queryKey: authKeys.quickLogin,
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async (): Promise<QuickLoginAccount[]> => {
      const res = await fetch("/api/quick-login");
      if (!res.ok) throw new Error(`Couldn't load quick sign-in (${res.status})`);
      return quickLoginSchema.parse(await res.json()).accounts;
    },
  });
}
